import React from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import './index.scss';

const GenericDndDropZone = ({ index, onMove, itemType, className }) => {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: itemType,
    drop: (draggedItem) => {
      if (draggedItem.index !== index) {
        onMove(draggedItem.index, index);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const isActive = canDrop && isOver;
  return (
    <div
      ref={drop}
      className={`generic-dnd-drop-zone ${className} ${
        isActive ? 'generic-dnd-drop-zone-active' : ''
      }`}
    >
      <div
        className={`generic-dnd-drop-zone-content ${
          isActive ? 'generic-dnd-drop-zone-content-active' : ''
        }`}
      ></div>
    </div>
  );
};

GenericDndDropZone.propTypes = {
  index: PropTypes.number.isRequired,
  onMove: PropTypes.func.isRequired,
  itemType: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default GenericDndDropZone;
